export default __webpack_public_path__ + "static/media/rates-select.ea6d7ff0.png";